var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.03906 6.5L12.8828 11.3438C13 11.4609 13 11.6562 12.8828 11.8125L12.0234 12.6719C11.8672 12.7891 11.6719 12.7891 11.5547 12.6719L10.7344 11.8516L6.75 7.82812L1.90625 12.6719C1.78906 12.7891 1.59375 12.7891 1.4375 12.6719L0.578125 11.8125C0.460938 11.6562 0.460938 11.4609 0.578125 11.3438L5.42188 6.5L0.578125 1.69531C0.460938 1.57812 0.460938 1.38281 0.578125 1.22656L1.4375 0.367188C1.59375 0.25 1.78906 0.25 1.90625 0.367188L6.75 5.21094L11.5547 0.367188C11.6719 0.25 11.8672 0.25 12.0234 0.367188L12.8828 1.22656C13 1.38281 13 1.57812 12.8828 1.69531L12.0625 2.51562L8.03906 6.5Z",
    fill: "#BC6B38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.9d537cf4a7f12e412e517daf6240d7cf.svg";
export { ForwardRef as ReactComponent };